import { createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../api';
import { setMessage } from '../../../redux/slice';

interface GetIssuesParams {
  status: string;
  page?: number;
  take?: number;
}

interface GetIssueParams {
  id: string;
}

export const doCreateIssue = createAsyncThunk('issues/doCreateIssue', async (params: any, thunkAPI) => {
  try {
    const { response, error } = await api.doCreateIssue(params);

    if (!error) thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
    if (!error) thunkAPI.dispatch(doGetIssue({ id: response.issueId }));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doMarkAsSeen = createAsyncThunk<any, any>('issues/doMarkAsSeen', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doMarkAsSeen(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doMarkAllAsSeen = createAsyncThunk<any, any>('issues/doMarkAllAsSeen', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doMarkAllAsSeen(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doGetIssues = createAsyncThunk<any, GetIssuesParams>('issues/doGetIssues', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doGetIssues(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doCreateComment = createAsyncThunk<any, any>('issues/doCreateComment', async (params, thunkAPI) => {
  const { issueLongId } = params;
  // delete params.issueLongId;
  try {
    const { response, error } = await api.doCreateComment(params);
    if (!error) await thunkAPI.dispatch(doGetIssue({ id: issueLongId }));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doCreateMissingComment = createAsyncThunk<any, any>(
  'issues/doCreateMissingComment',
  async (params, thunkAPI) => {
    // delete params.issueLongId;
    try {
      const { response, error } = await api.doCreateMissingComment(params);

      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doRemoveComment = createAsyncThunk<any, any>('issues/doCreateComment', async (params, thunkAPI) => {
  const { issueLongId } = params;
  // delete params.issueLongId;
  try {
    const { response, error } = await api.doRemoveComment(params);
    if (!error) await thunkAPI.dispatch(doGetIssue({ id: issueLongId }));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doGetIssue = createAsyncThunk<any, GetIssueParams>('issues/doGetIssue', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doGetIssue(params);
    if (!error) {
      // Re-fetch the list of issues to refresh the global state
      await thunkAPI.dispatch(doGetIssues({ status: 'active' }));
      await thunkAPI.dispatch(doGetIssues({ status: 'resolved' }));
      return response;
    } else {
      return thunkAPI.rejectWithValue(error);
    }
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUpdateIssue = createAsyncThunk<any, any>('issues/doUpdateIssue', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doUpdateIssue(params);
    if (!error) {
      await thunkAPI.dispatch(doGetIssue({ id: params.issueId }));
    }

    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doGetIssuesForOrder = createAsyncThunk('issues/doGetIssuesForOrder', async (params: any, thunkAPI) => {
  try {
    const { response, error } = await api.doGetIssuesForOrder(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doGetUnseen = createAsyncThunk<any, any>('issues/doGetUnseen', async (thunkAPI) => {
  try {
    const { response, error } = await api.doGetUnseenIssueCount();
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

// export const doUpdateIssue = createAsyncThunk<any, any>('issues/doUpdateIssue', async (params, thunkAPI) => {
//   try {
//     const { response, error } = await api.doUpdateIssue(params);
//     //if (!error) thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
//     console.log('updatd issue');
//     await thunkAPI.dispatch(doGetIssue({  params. id: params.id }));
//     console.log('should be done getting issue..');
//     return error ? thunkAPI.rejectWithValue(error) : response;
//   } catch (e) {
//     thunkAPI.rejectWithValue(e);
//     throw e;
//   }
// });
